import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as fromAuth from 'src/app/store/auth';
import { actionNeedsAuthentication } from 'src/app/store/auth/auth.actions';

@Injectable({
  providedIn: 'root',
})
export class CustomerGuard implements CanActivate, CanActivateChild {
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> {
    return this.store.pipe(
      select(fromAuth.selectAuthInfo),
      map(({ isAuthenticated, user }) => {
        if (!isAuthenticated || (!user.roles.includes('Customer') && !user.roles.includes('Administrator'))) {
          if (isAuthenticated && user.roles.includes('Auditor')) {
            this.store.dispatch(actionNeedsAuthentication({ returnUrl: '/auditing' }));
            return false;
          }

          this.store.dispatch(actionNeedsAuthentication({ returnUrl: routerState.url !== '/' ? routerState.url : undefined }));
          return false;
        }

        return true;
      }),
    );
  }

  constructor(private store: Store<fromAuth.AuthState>, private jwt: JwtHelperService, private router: Router) {}
}
